import { fetcher } from '@commenda/utils';

export interface UpdateAdminCompanyTestAccountParams {
  companyId: number;
  isTestAccount: boolean;
}

export interface UpdateAdminCompanyTestAccountResponse {
  isTestAccount: boolean;
}

export async function updateAdminCompanyTestAccount({
  companyId,
  isTestAccount,
}: UpdateAdminCompanyTestAccountParams): Promise<UpdateAdminCompanyTestAccountResponse> {
  const response = await fetcher(`admin/companies/${companyId}/test-account`, {
    method: 'PATCH',
    body: { isTestAccount },
  });

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: unknown;
      error?: unknown;
    } | null;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : Array.isArray(body?.message)
          ? body.message.join(', ')
          : typeof body?.error === 'string'
            ? body.error
            : 'Failed to update test account';
    throw new Error(message);
  }

  return response.json();
}
